export default "__VITE_ASSET__B6x$6hbz__"